// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// =================Material UI==================
import {
  Backdrop,
  Box,
  Fade,
  Modal,
} from '@mui/material';

// =================React Hook==================
import { useDispatch, useSelector } from 'react-redux';

// =================Dependancies==================
import DOMPurify from 'dompurify';

// =================Actions==================
import { setOpenCommandLineClientModal } from '../../../actions/header';

function ModalCommandLineClient() {
// ==================HOOK=========================
  const dispatch = useDispatch();
  const openCommandLineClientModal = useSelector(
    (state) => state.header.modal.commandLineClientModal,
  );
  const htmlContent = useSelector(
    (state) => state.header.htmlModal,
  );
  // ==================handler=========================
  const handleCloseCommandLineClientModal = () => {
    dispatch(setOpenCommandLineClientModal(false));
  };

  return (
    <Modal
      open={openCommandLineClientModal}
      onClose={handleCloseCommandLineClientModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 600,
        },
      }}
    >
      <Fade in={openCommandLineClientModal}>
        <Box className="commandLineClient--modal">
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlContent) }} />
          <div className="commandLineClient--modal__text--button">
            <button className="commandLineClient--modal__text--button__close" type="button" onClick={handleCloseCommandLineClientModal}>Close</button>
          </div>
        </Box>
      </Fade>

    </Modal>
  );
}

export default ModalCommandLineClient;
